
import React from 'react';
import Header from './Header';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center">
        <div className="text-center max-w-md px-4">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-primary mb-4"></div>
          <h2 className="text-xl font-semibold mb-2">{message}</h2>
          <p className="text-gray-600">
            {message.includes("Verifying") 
              ? "We're processing your authentication. This should take only a few seconds. If you're not redirected within 15 seconds, please try refreshing the page or clicking the magic link again." 
              : message.includes("Restoring")
              ? "We're retrieving your saved form data. This will help you pick up right where you left off."
              : "Please wait"}
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoadingState;
